export const typesUser = {
    login: 'login',
    logout: 'logout',
};
